export default __webpack_public_path__ + "static/media/dental.78fa2aa0.jpg";